import { isProductionBuild } from '@/utils/environment'

// TODO: remove once Pay Rent launches - shown on dev/staging only
export const IS_PAY_RENT_ENABLED = !isProductionBuild

// TODO: remove once the resident convenience fee (EL-11715) launches - shown on dev/staging only
export const IS_CONVENIENCE_FEE_ENABLED = !isProductionBuild
